export { TunnelClient, TunnelClientError } from './tunnel-client';
export type { TunnelClientConfig, AXElement } from './tunnel-client';
export { createTunnelTools } from './tools';
export type { TunnelToolDefinition, TunnelToolParameter } from './tools';
// CLI entrypoint: src/client/cli.ts (run via `bun run cli.ts <command> [json]`)
